// extracted by mini-css-extract-plugin
export default {"root":"tooltip_root__aJ+wS","tooltip":"tooltip_tooltip__+8zVI","tooltip_content":"tooltip_tooltip_content__9HBwa"};